import utils from "@/assets/js/utils.js";
// import context from '../main.js'
const urlParam = utils.getUrlParam(); //url里的参数
const host = ''; //配置ip及端口，默认为
const api = {
    submit: host + `/bpm-server/api/runtime/tasks/${urlParam.taskId}/actions/submit`,
    getUserInfo: host + '/bpm-admin/v1/api/user', // 用户信息
    logout: host + '/bpm-admin/v1/api/user/logout', // 退出
    getListByParentIdGroupByBizCode: host + `/bpm-admin/v1/api/carbonExternalApi/getListByParentIdGroupByBizCode`,
    getUcRoleTeamAndUcRole: host + `/bpm-admin/v1/api/carbonExternalApi/getUcRoleTeamAndUcRole`,
    getOrgLsAndUsers: host + `/bpm-admin/v1/api/carbonExternalApi/getOrgLsAndUsers`,
    getDeptProduceTree: `${host}/bpm-admin/v1/api/approval/remind-dept-produce-tree`, // 获取中心产品权限树
    getDeptProduceTreeOld: `${host}/bpm-admin/v1/api/approval/dept-produce-tree`, // 获取中心产品权限树 审批权限
    getAllChannel: `${host}/bpm-admin/v1/api/wfChannelDeptType/getAllChannel`, // 查询所有航道
    getAllDept: `${host}/bpm-admin/v1/api/wfChannelDeptType/getAllDept`, // 查询所有部门
    getAllProdName: `${host}/bpm-admin/v1/api/iam/alm/getAllProdName`, // 获取所有产品名
    getBusinessSystemCode: `${host}/bpm-admin/v1/api/catalog/first-system-code`, // 查询一级业务系统
    getProcess: `${host}/bpm-admin/v1/api/template/process`, // 获取流程模板名称
    getProcessTemplate: `${host}/bpm-admin/v1/api/approval/process-template`, // 获取权限审批信息
    approvalBasicData: `${host}/bpm-admin/v1/engine/approval/approval-basis-data`, // 保存审批权限数据
    getSystemProduceTree: `${host}/bpm-admin/v1/api/approval/system-produce-tree`, // 获取系统权限审批树
    getApprovalData: `${host}/bpm-admin/v1/api/approval/`, // 根据系统查询权限审批表 根据系统查询上线范围
    getAuthorityApprovalForm: `${host}/bpm-admin/v1/api/approval/authority-approval-form`, // 获取关联关系数据
    getOnlineBasis: `${host}/bpm-admin/v1/api/approval/online-basis`,// 获取上线依据
    getProduct: `${host}/bpm-admin/v1/api/approval/product`, // 获取产品信息
    getCatalog: `${host}/bpm-admin/v1/api/approval/catalog`, // 获取产品信息
    postCatalog: `${host}/bpm-admin/v1/engine/approval/catalog`, // 修改目录信息
    postApprovalApplication: `${host}/bpm-admin/v1/api/approval/approval-application`, // 上线审批申请
    processTemplateExport: `${host}/bpm-admin/v1/api/process-template/export`, // 导出
    getPermission: `${host}/bpm-admin/v1/api/process-template/permission`, // 权限
    getBusinessInfo: `${host}/bpm-admin/v1/engine/approval/`, // 查询审批权限业务信息
    deleteApprovalInvertory: `${host}/bpm-admin/v1/engine/approval/approval-invertory`,// 删除审批权限清单
    getChangeContent: `${host}/bpm-admin/v1/api/approval/change-content`,// 获取变更内容
    postBusinessInfo: `${host}/bpm-admin/v1/engine/approval/`, // 保存审批权限业务信息
    postRelatedLink: `${host}/bpm-admin/v1/engine/approval/related-link`, // 保存关联依据
    version: `${host}/bpm-admin/v1/api/template/version/`, // 详情页版本接口
    processConfig: `${host}/bpm-admin/v1/api/template/`, // 详情接口
    getSheet: `${host}/bpm-admin/v1/api/role-verification/sheet`, // 获取sheet页名称
    getSheetInfo: `${host}/bpm-admin/v1/api/role-verification/sheet-info`, // 获取sheet页名称
    searchApprovalTree: `${host}/bpm-admin/v1/api/approval/search-approval-tree`, // 搜索中心产品树
    verify: `${host}/bpm-admin/v1/api/role-verification/verify`, // 校验角色
    exportVerifyInfo: `${host}/bpm-admin/v1/api/role-verification/export`, // exportVerifyInfo
    downLoadfiles: `${host}/bpm-admin/v1/api/files`, // 附件
    getRoleSupplyDetailed: `${host}/bpm-admin/v1/api/engineExternalApi/process-role-supply/roleSupplyDetailed`, // 补人任务明细页面
    getRoleName: `${host}/bpm-admin/v1/api/engineExternalApi/process-role-supply/roleSupplyDetailed/getRoleName`, // 补人任务明细页面-获取角色范围
    getOrgName: `${host}/bpm-admin/v1/api/engineExternalApi/process-role-supply/roleSupplyDetailed/getOrgName`, // 补人任务明细页面-获取组织范围
    getMainProcessChName: `${host}/bpm-admin/v1/api/engineExternalApi/process-role-supply/roleSupplyDetailed/getMainProcessChName`, // 补人任务明细页面-获取模板范围
    getMainCatalogName: `${host}/bpm-admin/v1/api/engineExternalApi/process-role-supply/roleSupplyDetailed/getMainCatalogName`, // 补人任务明细页面-获取系统范围
    exportRoleSupplyDetailed: `${host}/bpm-admin/v1/api/roleSupply/exportRoleSupplyDetailed`, // 补人任务明细页面-导出
    getRoleSupplyStatistics: `${host}/bpm-admin/v1/api/roleSupply/roleSupplyStatistics`, // 角色补人统计
    getOrgNameForStatistics: `${host}/bpm-admin/v1/api/roleSupply/getOrgNameForStatistics`, // 角色补人统计-获取组织范围
    getRoleNameForStatistics: `${host}/bpm-admin/v1/api/roleSupply/getRoleNameForStatistics`, // 角色补人统计-获取角色范围
    getMainCatalogNameForStatistics: `${host}/bpm-admin/v1/api/roleSupply/getMainCatalogNameForStatistics`, // 角色补人统计-获取系统范围
    exportRoleSupplyStatistics: `${host}/bpm-admin/v1/api/roleSupply/exportRoleSupplyStatistics`, // 角色补人统计-导出
    getJsbqAmDetailed: `${host}/bpm-admin/v1/api/roleSupply/jsbqAmDetailed`, // AM补全明细
    getOrgNameForAmDetailed: `${host}/bpm-admin/v1/api/roleSupply/getOrgNameForAmDetailed`, // AM补全明细-获取组织范围
    getRoleNameForAmDetailed: `${host}/bpm-admin/v1/api/roleSupply/getRoleNameForAmDetailed`, // AM补全明细-获取角色范围
    getRoleInspectionList: `${host}/bpm-admin/v1/api/roleInspection/getRoleInspectionList`, // 角色巡检
    getAllOrg: `${host}/bpm-admin/v1/api/roleInspection/getAllOrg`, // 角色巡检-查询所有组织
    getAllRole: `${host}/bpm-admin/v1/api/roleInspection/getAllRole`, // 角色巡检-查询所有角色
    getAllSystem: `${host}/bpm-admin/v1/api/roleInspection/getAllSystem`, // 角色巡检-查询所有系统
    exportRoleInspectionStatistics: `${host}/bpm-admin/v1/api/roleInspection/exportRoleInspectionStatistics`, // 角色巡检-导出
    getRoleNoHavePerson: host + `/bpm-admin/v1/api/roleNoHavePerson/detail`, // 角色缺人明细
    getSystemName: host + `/bpm-admin/v1/api/roleNoHavePerson/getSystemName`,// 角色缺人明细-获取系统范围
    getTemplateName: host + `/bpm-admin/v1/api/roleNoHavePerson/getTemplateName`,// 角色缺人明细-获取模板范围
    exportDetailed: host + `/bpm-admin/v1/api/roleNoHavePerson/exportDetailed`,//角色缺人明细-导出
    getRoleNoHavePersonStatistics: host + `/bpm-admin/v1/api/roleNoHavePerson/statistics`, // 角色缺人统计
    getRoleNoHavePersonOrgStatistics: host + `/bpm-admin/v1/api/roleNoHavePerson/getOrgNameForStatistics`, // 角色缺人统计-获取组织范围
    getRoleNoHavePersonRoleStatistics: host + `/bpm-admin/v1/api/roleNoHavePerson/getRoleNameForStatistics`, // 角色缺人统计-获取角色范围
    getSystemNameStatistics: host + `/bpm-admin/v1/api/roleNoHavePerson/getSystemNameForStatistics`, // 角色缺人统计-获取系统范围
    exportStatistics: host + `/bpm-admin/v1/api/roleNoHavePerson/exportStatistics`, // 角色缺人统计-导出
    approvalProcConfig: `${host}/bpm-admin/v1/engine/approval/approval-proc-config`, // 询审批模板配置
    saveProcConfig: `${host}/bpm-admin/v1/engine/approval/save-proc-config`, // 保存审批模板配置
    getLaunchJSBQ: `${host}/bpm-admin/v1/api/roleSupply/launchJSBQ`, // 发起角色补全

    /*运维登记 -> 变更登记*/
    getChangeRecordRegisterQueryList: `${host}/bpm-admin/v1/api/change-record-register/queryList`, // 查询变更登记记录表
    getChangeRecordRegisterOperator: `${host}/bpm-admin/v1/api/change-record-register/getOperator`, // 获取角色范围
    getChangeRecordRegisterAllProdName: `${host}/bpm-admin/v1/api/change-record-register/getAllProdName`, // 获取所有产品
    getChangeRecordRegisterExport: `${host}/bpm-admin/v1/api/change-record-register/export`, // 导出变更登记记录

    resetChannelFunction: `${host}/bpm-admin/v1/api/approval/reset-channel-function`, // 重置航道和职能
    getAgent: `${host}/bpm-admin/v1/handover/`, // 获取待办交接审批信息
    createActions: host + `/bpm-admin/v1/handover/create`, // 添加交接任务
    getHandoverList: host + `/bpm-admin/v1/handover/handover-list`, // 待办交接列表
    putAgent: `${host}/bpm-admin/v1/handover/`, // 撤销交接待办 业务上级设置交接方式提交

    exportHandoverList: host + `/bpm-admin/v1/handover/handover/export`, // 导出交接任务列表

    /*待办周报统计 -> 职能超时审批周报*/
    overTime_todoStatistic: `${host}/bpm-admin/v1/api/overTime/todoStatistic`,
    overTime_todoCenterStatistic: `${host}/bpm-admin/v1/api/overTime/todoCenterStatistic`,

    /*模板配置*/
    getTemplateSystem: `${host}/bpm-admin/v1/api/catalog/getAllSystem`, // 所有系统查询
    getAllProcessDefTemp: `${host}/bpm-admin/v1/api/catalog/getAllProcessDefTemp`, // 查询所有流程定义模板
    getAllConfigManager: `${host}/bpm-admin/v1/api/template-config-manager/getProcessDefineConfig`, // 查询所有流程模板配置信息
    saveProcessDefineConfig:`${host}/bpm-admin/v1/api/template-config-manager/saveProcessDefineConfig`, // 保存所有流程模板配置信息

    /*系统配置表*/
    addCatalogInfoExpand: `${host}/bpm-admin/v1/api/catalogInfoExpand/addCatalogInfoExpand`, // 新增系统
    deleteCatalogInfoExpand: `${host}/bpm-admin/v1/api/catalogInfoExpand/deleteCatalogInfoExpand/`, // 删除系统
    getCatalogInfoList: `${host}/bpm-admin/v1/api/catalogInfoExpand/getList`,  // 获取系统列表
    updateCatalogInfoExpand: `${host}/bpm-admin/v1/api/catalogInfoExpand/updateCatalogInfoExpand`, // 根据guid修改系统名称

    /*模板详情页*/
    getTemplateDetailExplain:`${host}/bpm-admin/v1/api/template/explain/`, // 模板详情页获取模板说明和发起说明{模板编码}

    /*后台运维日志*/
    operationLog_getReporter: `${host}/bpm-admin/v1/api/operation-log/getReporter`, // 获取角色范围
    operationLog_get: `${host}/bpm-admin/v1/api/operation-log/`, // 查询后台运维日志详情
    operationLog_export: `${host}/bpm-admin/v1/api/operation-log/export`, // 导出Excel结果

    /*工联单下线进度*/
    getChannelList: `${host}/bpm-admin/v1/api/glz/statistic/getChannelList`, // 归口航道列表
    getFunctionList: `${host}/bpm-admin/v1/api/glz/statistic/getFunctionList`, // 归口职能列表
    getWorkRelationOfflineProgressChart: `${host}/bpm-admin/v1/api/glz/statistic/templateStatistic`, // 下线进度图
    getFunctionOfflineProgress: `${host}/bpm-admin/v1/api/glz/statistic/getFunctionOfflineProgress`, // 总览下线进度
    getTemplateOfflineProgress: `${host}/bpm-admin/v1/api/glz/statistic/getTemplateOfflineProgress`, // 模板下线进度
    templateOfflineProgressExport: `${host}/bpm-admin/v1/api/glz/statistic/templateOfflineProgressExport`, // 职能下线进度导出
    functionOfflineProgressExport: `${host}/bpm-admin/v1/api/glz/statistic/functionOfflineProgressExport`, // 总览下线进度
    getWorkRelationTemplateList: `${host}/bpm-admin/v1/api/remind/templateRange/queryList`,// 查询工联单模板列表
    updateWorkRelationTemplate: `${host}/bpm-admin/v1/api/remind/templateRange/update`,// 更新工联单模板信息
    getChangelogByFlowModelno: `${host}/bpm-admin/v1/api/remind/templateRange/query`,// 获取工联单模板下线变更记录
    templateOfflineExport: `${host}/bpm-admin/v1/api/remind/templateRange/templateOfflineExport`, // 工联单看板维护导出

    /*看板明细*/
    getLimitAuthorityChannel: `${host}/bpm-admin/v1/api/flowkanban/channel`, // 获取有权限控制的归口航道
    getLimitAuthorityFuntion: `${host}/bpm-admin/v1/api/flowkanban/dept`, // 获取有权限控制的归口职能
    getLimitAuthorityProduct: `${host}/bpm-admin/v1/api/flowkanban/product`, // 获取有权限控制的产品
    getLimitAuthoritySystemName: `${host}/bpm-admin/v1/api/flowkanban/queryTodoSystemname`, // 获取有权限控制的系统名称
    getLimitAuthorityProcessName: `${host}/bpm-admin/v1/api/flowkanban/queryFlowModelname`, // 获取有权限控制的模板名称
    getLimitAuthoritySponsorChannel: `${host}/bpm-admin/v1/api/flowkanban/querySponsorBusinessUnit`, // 获取有权限控制的发起人航道
    getLimitAuthoritySponsorFuntion: `${host}/bpm-admin/v1/api/flowkanban/querySponsorJobFunction`, // 获取有权限控制的发起人职能
    getLimitAuthoritySponsorCompany: `${host}/bpm-admin/v1/api/flowkanban/querySponsorArea`, // 获取有权限控制的发起人公司
    getFlowDetail: `${host}/bpm-admin/v1/api/flowkanban/flowDetailList`, // 流程明细看板
    exportFlowDetailList: `${host}/bpm-admin/v1/api/flowkanban/flowDetailListExport`, // 流程明细看板导出
    getSyncStatus: `${host}/bpm-admin/v1/api/todosyncrecord/getSyncStatus`, // 查看启动信息获取日期
    getWorkFlowDetailPermission: `${host}/bpm-admin/v1/api/flowkanban/permission`, // 权限
    /* 获取业务异常信息 */
    getExceptionMessage: `${host}/bpm-admin/v1/api/exception-message`, // 获取业务异常信息
    /*趋势看板*/
    getTrendBoardTotal: `${host}/bpm-admin/v1/api/flowMonth/trendTotalStatistic`, // 获取趋势看板合计
    getTrendBoardChartNew: `${host}/bpm-admin/v1/api/flowMonth/newFlowMonthStatis`, // 新流程量/待办量月度/季度趋势看板
    exportTrendBoard: `${host}/bpm-admin/v1/api/flowMonth/flowMonthStatisExport`,// 趋势看板导出
    /*职能看版*/
    getEachFunctionTableData: `${host}/bpm-admin/v1/api/flowMonth/moduleTotalStatis`,// 各职能看板
    getfunctionTableData: `${host}/bpm-admin/v1/api/flowMonth/moduleStatis`,// 职能看板
    exportFunctionBoard: `${host}/bpm-admin/v1/api/flowMonth/moduleStatisExport`,// 职能看板导出

    // RACI数据获取和提交
    getRaciData: `${host}/bpm-admin/v1/api/template/`,
    // 配置参数
    myMaintainUrl: `${host}/bpm-server/api/system-info/infos`,
    delMaintainUrl: `${host}/bpm-server/api/system-info/`,
    addMaintainUrl: `${host}/bpm-server/api/system-info`,

}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js